import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DashboardIcon from '../../assets/svgs/DashboardIcon';
import NotificationIcon from '../../assets/svgs/NotificationIcon';
import StatsIcon from '../../assets/svgs/StatsIcon';
import SettingsIcon from '../../assets/svgs/SettingsIcon';
import ProfileIcon from '../../assets/svgs/ProfileIcon';
import toFa from '../../helpers/toFa';

const Navigation = ({ className }) => {
    return (
        <nav className={className}>
            <ul>
                <li>
                    <NavLink exact activeClassName="is-active" to="/dashboard">
                        <DashboardIcon />
                        <span>همه پرسش‌ها</span>
                    </NavLink>
                </li>

                <li>
                    <NavLink exact activeClassName="is-active" to="/stats">
                        <StatsIcon />
                        <span>داده‌های آماری</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink exact activeClassName="is-active" to="/profile">
                        <ProfileIcon />
                        <span>حساب کاربری</span>
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
};

Navigation.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Navigation)`
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    height: 70px;
    width: 100%;
    background: #0d1fa1;
    display: flex;
    flex-flow: column;
    justify-content: center;
    max-width: 480px;
    margin: 0 auto;

    ul {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
        align-items: center;

        li {
            display: flex;
            align-items: center;
        }
    }

    a {
        display: flex;
        flex-flow: column;
        align-items: center;
        position: relative;

        span {
            font-size: 10px;
            line-height: 17px;
            font-weight: 500;
            color: #fff;
            height: 0;
            overflow: hidden;
        }

        &.is-active {
            svg g > * {
                stroke: #fff;
            }

            span {
                margin-top: 7px;
                height: auto;
            }
        }
    }
`;
